import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { ButtonTemplate } from '../ButtonTemplate';
import * as styles from './CategoryChip.module.scss';
export const CategoryChip = ({ as, ref, className, children, bottomLineColor = '#0033ff', ...rest }) => {
    const hoverColor = (hexColor) => {
        const [red, green, blue] = hexColor.match(/\w{2}/g) ?? ['00', '33', 'ff'];
        return `rgba(${parseInt(red, 16)}, ${parseInt(green, 16)}, ${parseInt(blue, 16)}, 0.1)`;
    };
    return (_jsxs(ButtonTemplate, { as: as, ref: ref, className: cn(className, styles.chip, 'u-p-h-xl', 'u-p-h-sm-s', 'u-p-h-md-s', 'u-border-width-1', 'u-border-style-solid', 'u-border-color-light-gray', 'u-flex--inline', 'u-flex--align-items-center', 'u-flex--justify-content-center', 'u-color-secondary', 'u-typography-body-s'), onMouseOver: (event) => {
            const chip = event.currentTarget;
            chip.style.backgroundColor = hoverColor(bottomLineColor);
        }, onMouseLeave: (event) => {
            const chip = event.currentTarget;
            chip.style.backgroundColor = 'unset';
        }, ...rest, children: [children, _jsx("div", { className: styles.bar, style: { backgroundColor: bottomLineColor } })] }));
};
//# sourceMappingURL=CategoryChip.js.map